import {
  HHBaseTable,
  HHButton,
  HHStack,
} from '@hinge-health/react-component-library';
import { PackageType } from '../../types';
import { ActiveStatus } from '../../utils/contract-utils';
import { formatSubscriptionTier, IDiscount } from '../../utils/discount-utils';
import { ScopeDisplay } from '../scope-display/scope-display';
import { TextGrouping } from '../utils/text-grouping';

interface MilestoneCellProps {
  discount: number;
  alloc: number;
}

const MilestoneCell = ({
  discount,
  alloc,
}: MilestoneCellProps): JSX.Element => (
  <span>
    {`${Math.round(alloc * 100)}% × $${discount} = `}
    <strong>{`$${(discount * alloc).toFixed(2)}`}</strong>
  </span>
);

export interface VbdDetailProps {
  discount: IDiscount;
  availablePackages: PackageType[];
  onEdit?: (discountDefinitionId: number) => void;
}

const VbdDetail = ({ discount, onEdit }: VbdDetailProps): JSX.Element => (
  <HHStack direction="column" spacing={4} padding={4}>
    <HHStack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <HHStack direction="row" spacing={6}>
        <ScopeDisplay scopes={discount.scopes} />
        <TextGrouping
          label="Suppress Empty Charges"
          text={discount.suppressEmptyCharges ? 'Yes' : 'No'}
        />
      </HHStack>
      {onEdit && (
        <HHButton
          hhVariant="variant-bypass"
          variant="outlined"
          size="small"
          disabled={discount.status !== ActiveStatus.Future}
          onClick={(): void => onEdit(discount.discountDefinitionId)}
        >
          Edit
        </HHButton>
      )}
    </HHStack>
    <HHBaseTable
      headerRowBottomBorder="1px solid rgba(0, 0, 0, 0.12)"
      bodyRowBorder={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
      bodyTypographyVariant="inherit"
      tableHeaders={[
        { value: 'Tier', align: 'left' },
        { value: 'Subscription Range', align: 'left' },
        { value: 'Tier Discount ($)', align: 'left' },
        { value: 'C1 Discount', align: 'left' },
        { value: 'C2 Discount', align: 'left' },
        { value: 'C3 Discount', align: 'left' },
      ]}
      bodyContent={discount.discountDetails.map(row => {
        const ms = row.milestoneDiscount as Record<string, number>;

        return {
          tier: { value: row.tier },
          subscriptionRange: {
            value: formatSubscriptionTier(row.subscriptionTier),
          },
          discount: { value: `$${row.discount}` },
          c1: {
            value: (
              <MilestoneCell discount={row.discount} alloc={ms?.c1 ?? 0} />
            ),
          },
          c2: {
            value: (
              <MilestoneCell discount={row.discount} alloc={ms?.c2 ?? 0} />
            ),
          },
          c3: {
            value: (
              <MilestoneCell discount={row.discount} alloc={ms?.c3 ?? 0} />
            ),
          },
        };
      })}
    />
  </HHStack>
);

export default VbdDetail;
